import { render, staticRenderFns } from "./loyalty-link-account-app-card.vue?vue&type=template&id=6fffbf2c&"
import script from "./loyalty-link-account-app-card.vue?vue&type=script&lang=js&"
export * from "./loyalty-link-account-app-card.vue?vue&type=script&lang=js&"
import style0 from "./loyalty-link-account-app-card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports